import { render, staticRenderFns } from "./wtGoogleSignin.vue?vue&type=template&id=a9a76f52&scoped=true&"
import script from "./wtGoogleSignin.vue?vue&type=script&lang=js&"
export * from "./wtGoogleSignin.vue?vue&type=script&lang=js&"
import style0 from "./wtGoogleSignin.vue?vue&type=style&index=0&id=a9a76f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a76f52",
  null
  
)

export default component.exports